(function() {
	'use strict';

	// Add additional JS in separate include files and require them with relative paths
	// require('./tables.js');
	require('./offsite-links.js');
}());
